export default "__VITE_ASSET__ChjWL$UD__"